<template>
  <v-layout
    class="pa-4"
    row
    wrap
    justify-center
  >
    <v-flex>
      <div class="display-1 grey--text text--darken-1">
        Login
      </div>
      <v-form
        ref="form"
        v-model="formValid"
        class="pa-3"
        @submit.prevent="login"
      >
        <v-text-field
          v-model="email"
          :rules="validationRules.email"
          name="email"
          label="Email"
          type="email"
          required
        />
        <v-text-field
          v-model="password"
          :rules="[
            v => !!v || 'Password is required',
            v => (!!v && v.length > 5) || 'Password must have min 6 characters'
          ]"
          :append-icon="passwordVisible ? 'visibility_off' : 'visibility'"
          :type="passwordVisible ? 'text' : 'password'"
          name="password"
          required
          label="Password"
          @click:append="() => (passwordVisible = !passwordVisible)"
        />
        <v-btn
          id="loginButton"
          :loading="loading"
          color="primary"
          type="submit"
        >
          Login
        </v-btn>
      </v-form>
      <router-link
        class="subheading"
        to="/login/forgot-password"
      >
        Forgot Password?
      </router-link>
    </v-flex>
    <v-snackbar
      v-model="snackbar"
      :timeout="0"
      :color="snackbarColor"
      absolute
      multi-line
      bottom
    >
      {{ snackbarMessage }}
      <v-btn
        flat
        @click.native="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
import validationRules from '@/mixins/validation-rules';
import { auth } from '@/firebase';

export default {
  name: 'LoginForm',
  mixins: [validationRules],
  data() {
    return {
      email: null,
      password: null,
      passwordVisible: false,
      formValid: false,
      loading: false,
      snackbar: false,
      snackbarColor: 'primary',
      snackbarMessage: ''
    };
  },
  methods: {
    login() {
      const { form } = this.$refs;
      if (!form.validate()) return;
      this.loading = true;
      auth.signInWithEmailAndPassword(this.email, this.password).catch(error => {
        this.snackbarColor = 'error';
        if (error.code === 'auth/user-disabled') {
          this.snackbarMessage = 'Your account has been disabled. Please contact admin.';
        } else if (error.code === 'auth/user-not-found') {
          this.snackbarMessage = 'Account does not exists';
        } else if (error.code === 'auth/wrong-password') {
          this.snackbarMessage = 'Wrong password or password is not set';
        } else {
          this.snackbarMessage = error.message;
        }
        this.snackbar = true;
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
#loginButton {
  width: 210px;
}
</style>
